// Catalog slice — loads the public product catalog once and caches it.
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../api/public-client.js';

export const fetchCatalog = createAsyncThunk(
  'catalog/fetch',
  async (_arg, { rejectWithValue }) => {
    try {
      return await apiFetch('/api/catalog');
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const catalogSlice = createSlice({
  name: 'catalog',
  initialState: {
    data: null, // { categories, products, options, includes }
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCatalog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCatalog.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCatalog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to load catalog';
      });
  },
});

export default catalogSlice.reducer;
